// extracted by mini-css-extract-plugin
export var notificationHost = "_ie-0";